import React, { FunctionComponent } from "react"
import PureImage from "../../components/Image/PureImage"
import { iSpace } from "../../definitions/Space"
import { eImageVersions } from "../../definitions/Image"
import { useImageUrl } from "../../hooks/useImageUrl"

import s from "./Spaces.less"

const Item: FunctionComponent<iSpace> = ({ title, subtitle, fileVersions }) => {
  const url = useImageUrl(eImageVersions.LIcon, fileVersions)
  return (
    <div className="content-item">
      <div className="content-image">
        <PureImage className={s.image} src={url} />
      </div>
      <div className="content-block">
        <h3>{title}</h3>
        <span>{subtitle}</span>
      </div>
    </div>
  )
}

export default Item
